import {
  BrandingCard,
  DistributionCard,
  DocumentsGenerationCard,
  ExperimentalCard,
  GenieInsights,
  GenieMailboxCard,
  GenieSuiteCard,
  GeniePageCard,
  IdentityProfileCard,
  KnowledgeCard,
  ListeningAlertsCard,
  MeetingsCard,
  UsageBillingCard,
} from "@/components/agent/details";
import { GenieDetailSectionsProps } from "./genieDetailSections";

// A listener records meetings rather than talking to anyone, so the voice,
// conversation and live-page sections are not rendered. Links to them land on
// Identity & Purpose; grid pairs fall back to the wrapper that holds them.
export const LISTENER_SECTION_FALLBACKS: Record<string, string> = {
  "section-voice": "section-identity",
  "section-prompts": "section-identity",
  "section-welcome": "section-identity",
  "section-pronunciations": "section-identity",
  "section-context-source": "section-identity",
  "section-resources": "section-identity",
  "section-closing": "section-identity",
  "section-webhook": "section-reports",
  "section-tools": "section-identity",
  "section-client-events": "section-identity",
  "section-intelligence": "section-identity",
  "section-behavior": "section-identity",
  "section-extra": "section-identity",
  "section-usage": "section-reports",
};

export const ListenerGenieSections = ({
  genie,
  brand,
  layout,
  isAdmin,
  knowledgeNotice,
  onOpenModal,
  distributionRef,
}: GenieDetailSectionsProps) => {
  if (layout === "grid") {
    return (
      <div className="flex flex-col gap-6">
        <div id="section-meetings">
          <MeetingsCard agent={genie} brand={brand} />
        </div>
        <div id="section-distribution" ref={distributionRef}>
          <DistributionCard agent={genie} brand={brand} onAction={onOpenModal} />
        </div>
        <div id="section-suite">
          <GenieSuiteCard agent={genie} brand={brand} />
        </div>
        <div id="section-identity">
          <IdentityProfileCard agent={genie} brand={brand} />
        </div>
        <div id="section-insights">
          <GenieInsights agent={genie} />
        </div>
        <div id="section-knowledge">
          {knowledgeNotice}
          <KnowledgeCard agent={genie} brand={brand} />
        </div>
        <div id="section-documents">
          <DocumentsGenerationCard agent={genie} brand={brand} />
        </div>
        <div id="section-genie-page">
          <GeniePageCard agent={genie} brand={brand} />
        </div>
        <div id="section-branding">
          <BrandingCard agent={genie} brand={brand} onSwitchModal={onOpenModal} />
        </div>
        <div id="section-mailbox">
          <GenieMailboxCard agent={genie} brand={brand} />
        </div>
        <div id="section-reports" className="grid grid-cols-2 gap-6">
          <ListeningAlertsCard agent={genie} brand={brand} />
          <UsageBillingCard agent={genie} brand={brand} />
        </div>
        {isAdmin && (
          <div id="section-experimental">
            <ExperimentalCard agent={genie} brand={brand} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-4 lg:space-y-6">
      <div id="section-meetings">
        <MeetingsCard agent={genie} brand={brand} />
      </div>
      <div id="section-distribution" ref={distributionRef}>
        <DistributionCard agent={genie} brand={brand} onAction={onOpenModal} />
      </div>
      <div id="section-suite">
        <GenieSuiteCard agent={genie} brand={brand} />
      </div>
      <div id="section-identity">
        <IdentityProfileCard agent={genie} brand={brand} />
      </div>
      <div id="section-insights">
        <GenieInsights agent={genie} />
      </div>
      <div id="section-knowledge">
        {knowledgeNotice}
        <KnowledgeCard agent={genie} brand={brand} />
      </div>
      <div id="section-documents">
        <DocumentsGenerationCard agent={genie} brand={brand} />
      </div>
      <div id="section-branding">
        <BrandingCard agent={genie} brand={brand} onSwitchModal={onOpenModal} />
      </div>
      <div id="section-mailbox">
        <GenieMailboxCard agent={genie} brand={brand} />
      </div>
      <div id="section-reports">
        <ListeningAlertsCard agent={genie} brand={brand} />
      </div>
      <div id="section-usage">
        <UsageBillingCard agent={genie} brand={brand} />
      </div>
      {isAdmin && (
        <div id="section-experimental">
          <ExperimentalCard agent={genie} brand={brand} />
        </div>
      )}
    </div>
  );
};
